import React, { FC } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { Info } from "@material-ui/icons";
import { TEXTS } from "../../constants";
import StyledTooltip from "../Common/StyledTooltip";

const useStyles = makeStyles((theme: Theme) => ({
  infoIcon: {
    color: theme.palette.primary.main,
    cursor: "default",
    marginLeft: "6px",
  },
}));

const InfoIcon: FC = () => {
  const classes = useStyles();

  return (
    <StyledTooltip title={TEXTS.INDICATION_TOOLTIP}>
      <Info fontSize="small" className={classes.infoIcon} />
    </StyledTooltip>
  );
};

export default InfoIcon;
